import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
// slices
import exchangerateReducer from "./slices/exchangerate";
import generaleReducer from "./slices/generale";
import usersReducer from "./slices/users";
import agentReducer from "./slices/agent";
import customerReducer from "./slices/customer";
import feeReducer from "./slices/fee";
import supervisorReducer from "./slices/supervisor";
import limittransactionReducer from "./slices/limittransaction";
import countryReducer from "./slices/countries";
import categoryReducer from "./slices/categories";
import ticketReducer from "./slices/ticket";
import reportReducer from "./slices/report";
import walletReducer from "./slices/wallet";
import usercommissionReducer from "./slices/usercommission";
import sendtopupReducer from "./slices/sendtopup";
import sendmoncashReducer from "./slices/sendmoncash";
import remesasReducer from "./slices/remesas";

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  remesas: remesasReducer,
  sendtopup: sendtopupReducer,
  sendmoncash: sendmoncashReducer,
  usercommission: usercommissionReducer,
  wallet: walletReducer,
  ticket: ticketReducer,
  report: reportReducer,
  generale: generaleReducer,
  exchangerate: exchangerateReducer,
  supervisor: supervisorReducer,
  agent: agentReducer,
  customer: customerReducer,
  fee: feeReducer,
  limit_transaction: limittransactionReducer,
  country: countryReducer,
  categories: categoryReducer,
  users: usersReducer,
});

export { rootPersistConfig, rootReducer };
